import { useContext } from "react";

import ClientContext from "../context/ClientContext";

export default function useRequireCurrentClient() {
    const data = useContext(ClientContext);
    if (!data.client) throw Error("Client required");
    return data?.client;
}
